var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnathorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#e2e2e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#ddd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#d0d0d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#dedede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.256,
    stopColor: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    stopColor: "#d7d7d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.733,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854,
    stopColor: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bfbfbf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff000f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fe010f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.286,
    stopColor: "#fb0210"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#f60410"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f00511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#e90511"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e10612"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#da0713"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913,
    stopColor: "#d20814"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cc0814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#995929",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#955728",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#8f5325",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#894f22",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#814a1f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.647,
    stopColor: "#7a441b",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#734017",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.869,
    stopColor: "#6e3c14",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#232323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#212121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#985929",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#965728",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#925527",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#8e5225",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#894f22",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#834b1f",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7c461c",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#744118",
    stopOpacity: 0.902
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13",
    stopOpacity: 0.902
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.5,
    y1: 0.003,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#2d2d2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#272727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#242424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f1f1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9a5a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.169,
    stopColor: "#985929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.311,
    stopColor: "#965728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#925527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#8e5225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#894f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#834b1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808,
    stopColor: "#7c461c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#744118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c3b13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.061,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#454545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.446,
    stopColor: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#494949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.721,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.5,
    y1: 0.002,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.248,
    stopColor: "#484848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339,
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.439,
    stopColor: "#444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#414141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "#404040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "access-denied",
    transform: "translate(-666 -245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AccessDenied",
    transform: "translate(666 245)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M238.513,201.049c-22.026,24.39-66.107,30.943-107.758,30.951-41.654-.056-80.94-6.524-104.283-28.478-23.413-21.95-30.8-59.261-24.113-94.291C9.055,74.265,29.9,41.575,59.3,29.622s67.344-3.171,102.355,10.7,67.089,32.836,83.072,63.434S260.608,176.655,238.513,201.049Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(19.998 37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M105,0V194.95c-39.493-.637-76.26-7.489-98.524-28.428A71.537,71.537,0,0,1,0,159.576L0,0Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M105,0V194.95q-4.675-.075-9.293-.27V9.293H9.294V169.032q-1.444-1.22-2.816-2.51A71.41,71.41,0,0,1,0,159.577V0Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M64.494,118.421a5.025,5.025,0,0,1,2.029-3.517l3.735-2.744a5.16,5.16,0,0,1,5.64-.3l2.2-1.615a5.01,5.01,0,0,1,1.314-4.619l3.239-3.3a5.148,5.148,0,0,1,5.015-1.354l1.54-1.464a5.01,5.01,0,0,1,.84-5.389l3.081-3.448a5.15,5.15,0,0,1,5.487-1.43L101.7,86.5a2,2,0,0,1,2.8.149,1.942,1.942,0,0,1-.151,2.764l-2.772,2.461a5.011,5.011,0,0,1-.8,5.481L97.694,100.8a5.151,5.151,0,0,1-5.6,1.39l-1.3,1.233a5.012,5.012,0,0,1-.818,5.926l-3.239,3.3a5.156,5.156,0,0,1-6.347.782l-2.134,1.568a5.024,5.024,0,0,1-1.912,5.255L72.612,123a5.15,5.15,0,0,1-6.953-.8l-3.367.529a1.958,1.958,0,1,1-.621-3.866Zm5.04,2.849a2.356,2.356,0,0,0,1.431-.456l3.735-2.745a2.3,2.3,0,0,0,.9-1.419,1.991,1.991,0,0,1-1.844-.774,1.939,1.939,0,0,1-.218-1.969,2.355,2.355,0,0,0-1.634.445L68.17,117.1a2.311,2.311,0,0,0-.716.86l.438-.069a1.976,1.976,0,0,1,2.265,1.626,1.944,1.944,0,0,1-.625,1.757Zm29.75-27.434a2,2,0,0,1-2.422-.41,1.939,1.939,0,0,1-.474-1.659,2.334,2.334,0,0,0-1.193.714l-3.081,3.448a2.292,2.292,0,0,0-.584,1.628,2,2,0,0,1,2.057.5,1.939,1.939,0,0,1,.521,1.709,2.342,2.342,0,0,0,1.516-.769L98.7,95.547a2.293,2.293,0,0,0,.579-1.711ZM88.616,105.422a2,2,0,0,1-2.422-.335,1.94,1.94,0,0,1-.55-1.467,2.334,2.334,0,0,0-1.013.607l-3.239,3.3a2.3,2.3,0,0,0-.658,1.532,1.977,1.977,0,0,1,1.256.762,1.935,1.935,0,0,1,.358,1.52,2.363,2.363,0,0,0,2.407-.59l3.239-3.3a2.3,2.3,0,0,0,.621-2.03Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M44.418,119.278h2.159c.579,0,.553,4.05,0,4.05H43.967a5.312,5.312,0,0,1-5,2.658l-4.808-.351a5.258,5.258,0,0,1-4.9-5.131l-2.425-1.513a5.352,5.352,0,0,1-5.85.132L16.9,116.58a5.2,5.2,0,0,1-2.144-6.207l-1.612-1.927a5.331,5.331,0,0,1-4.619-1.187l-3.614-3.151a5.187,5.187,0,0,1-1.368-5.956L.659,95.511a2.007,2.007,0,0,1-.112-2.862,2.069,2.069,0,0,1,2.9-.11L6.5,95.327a5.346,5.346,0,0,1,5.42.95l3.614,3.151a5.184,5.184,0,0,1,.986,6.682l1.071,1.28a5.348,5.348,0,0,1,4.967.358l4.076,2.543a5.2,5.2,0,0,1,2.392,5.274l1.82,1.136a5.315,5.315,0,0,1,4.092-1.483l4.808.35a5.284,5.284,0,0,1,4.677,3.709Zm-3.749,3.511a2.006,2.006,0,0,1-.658-1.484,2.029,2.029,0,0,1,1.331-1.9,2.431,2.431,0,0,0-1.811-1.019l-4.808-.35a2.442,2.442,0,0,0-1.474.364,2.005,2.005,0,0,1,.038,2.222,2.033,2.033,0,0,1-.954.792,2.429,2.429,0,0,0,2.032,1.4l4.808.35a2.431,2.431,0,0,0,1.495-.378Zm-16.436-5.724a2,2,0,0,1,.069-2.048,2.059,2.059,0,0,1,1.844-.941,2.394,2.394,0,0,0-1.044-1.395l-4.076-2.543a2.44,2.44,0,0,0-1.545-.356,2.01,2.01,0,0,1-.579,2.361,2.065,2.065,0,0,1-1.559.448,2.391,2.391,0,0,0,1.091,1.6l4.076,2.543a2.439,2.439,0,0,0,1.724.331Zm-12.845-11.41a2.014,2.014,0,0,1,.744-1.6,2.073,2.073,0,0,1,2.274-.224,2.381,2.381,0,0,0-.771-2.279L10.021,98.4a2.425,2.425,0,0,0-1.213-.568,2.006,2.006,0,0,1-.462,1.951,2.07,2.07,0,0,1-2.356.467,2.378,2.378,0,0,0,.819,1.742l3.614,3.151a2.421,2.421,0,0,0,.964.515Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(46.374 111.441) rotate(2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 16,
    height: 16,
    rx: 3,
    transform: "translate(0.1 1.663) rotate(-4)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M7.679,9.542a2.2,2.2,0,0,1-1.023-1.88A2.111,2.111,0,0,1,8.7,5.492a2.111,2.111,0,0,1,2.045,2.17,2.2,2.2,0,0,1-1.023,1.88V12a1.024,1.024,0,1,1-2.045,0Z",
    transform: "translate(-0.627 0.63) rotate(-4)",
    fill: "#1f1f1f",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(112.155 110.934)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M39.959,34.7l-1.134,2.67c-1.511,3.56-4.84,9.238-10.96,6.641q-6.12-2.6-10.127-9.551,5.82.632,7.291-2.946c1.471-3.577,2.386-5.657,4.948-11.769-1.435-5.488-.052-8.175,2.52-9.386Q41.115,6.3,56.081,15.284,50.765,31.934,45.4,35.176,43.108,36.565,39.959,34.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M39.959,34.7l-1.134,2.67c-1.511,3.56-4.84,9.238-10.96,6.641q-6.12-2.6-10.127-9.551,5.82.632,7.291-2.946c1.471-3.577,2.386-5.657,4.948-11.769-1.435-5.488-.052-8.175,2.52-9.386Q41.115,6.3,56.081,15.284,50.765,31.934,45.4,35.176,43.108,36.565,39.959,34.7Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M39.959,34.7l-1.134,2.67A12.574,12.574,0,0,1,33.3,28.726,17.514,17.514,0,0,0,39.959,34.7Z",
    fill: "#6c3b13",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M35.554,14.241a2.454,2.454,0,0,0-2.619-1.567c-3.517.274-3.773,6.94-1.214,8.026.668.284.285,2.567-3.309,2.77.992-2.337-.288-9.68,1.638-15.079C30.976,3.223,36.988.354,43.324.95q6.336.6,19.72,8.149-.611,7.7-6.98,8.761c-2.62.437-7.66-1.112-14.628-4.07-1.052-.446-1.752-.435-2.01.99C38.926,17.542,36.49,20.7,35.554,14.241Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M118.215,117.627q-13.209,1.6-13.518.85c-.173-.579-1.1-8.9,1.235-8.959,1.5-.054,14.7-.355,16.492.5C122.55,110.08,119.109,117.714,118.215,117.627Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M118.215,117.627q-13.209,1.6-13.518.85c-.173-.579-1.1-8.9,1.235-8.959,1.5-.054,14.7-.355,16.492.5C122.55,110.08,119.109,117.714,118.215,117.627Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M27.7,88.808S63.338,71.652,70.2,74.18s25.6,34.912,25.6,34.912l-12.83-.033Q66.9,91.7,62.217,91.781T45.094,106.648l-25.283-1.06Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M5.633,105.781q11.633-5.659,26.751-5.282t81.543,7.99s2.135,7.035-1.949,11.293c0,0-33.894,1.354-62.236,1.812-18.5.3-34.631.215-37.432-.876Q5.217,117.956,5.633,105.781Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M65.774,66.375C70.11,66.3,75.9,72.03,76.285,74.619s-1.311,2.251-1.71,2.248c-2.2.108-2.257-2.009-4.4-2.525-1.379-.332-2.79.064-4.2,0-1.709-.1-3.686-2.389-4.5-3.9-.59-1.118-1.229-1.79-1.229-3C60.245,66.688,64.3,66.292,65.774,66.375Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M65.774,66.375C70.11,66.3,75.9,72.03,76.285,74.619s-1.311,2.251-1.71,2.248c-2.2.108-2.257-2.009-4.4-2.525-1.379-.332-2.79.064-4.2,0-1.709-.1-3.686-2.389-4.5-3.9-.59-1.118-1.229-1.79-1.229-3C60.245,66.688,64.3,66.292,65.774,66.375Z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M42.6,66.138a.746.746,0,0,0,.944.863l19.069-.708a18.6,18.6,0,0,1,.191,6.97,2.064,2.064,0,0,1-.387,1.054,2.271,2.271,0,0,1-1.442.578,124.512,124.512,0,0,0-23.6,5.864,4.582,4.582,0,0,1-2.462.418c-1.566-.318-2.308-2.1-2.661-3.657-1.188-5.244-.878-10.7-1.593-16.032-.351-2.591-.923-5.337.112-7.745.949-2.229,6.8-14.072,8.365-10.583,1.028,2.313,2.18,12.088,2.52,14.59Q42.259,61.926,42.6,66.138Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M73.368,69.689c1.025,1.383.549,2.514-.983,3.82-1.192,1.016-2.815,1.327-4.267,1.876s-2.807,1.85-4.069,2.491c-2.675,1.358-4.992,2.086-6.247,1.732-1.308-.369-4.553-3.6-2.657-5.684.78-.857,6.448-.276,7.578-1.722a28.956,28.956,0,0,0,3.339-5.695C67.95,64.28,72.343,68.306,73.368,69.689Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M73.368,69.689c1.025,1.383.549,2.514-.983,3.82-1.192,1.016-2.815,1.327-4.267,1.876s-2.807,1.85-4.069,2.491c-2.675,1.358-4.992,2.086-6.247,1.732-1.308-.369-4.553-3.6-2.657-5.684.78-.857,6.448-.276,7.578-1.722a28.956,28.956,0,0,0,3.339-5.695C67.95,64.28,72.343,68.306,73.368,69.689Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M32.141,91.664c.387,2.956.973,5.968.244,8.885-.841,3.313-3.311,6.073-6.128,8.245a32.977,32.977,0,0,1-19.479,6.672C2.878,115.533-1.6,74.277.566,65.39S4.676,47.145,11.827,40.916a21.725,21.725,0,0,1,7.988-4.663c11.133-3.266,23.08,2.073,19.317,13.437C34.516,63.628,30.18,76.676,32.141,91.664Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M14.986,53.839c-3.06-14.467-.289-13.146,9.4-14.214s12.922,6.337,11.056,14.331,1.866,19.217,1.866,19.217L63.346,71.02,64.465,78.5S28.036,90.2,25.951,87.861,21.238,80.99,14.986,53.839Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M26.839,30.116c3.44,3.021,6.57,6.355,10.559,8.557,3.072,1.7,3.277,6.649-1.052,4.216-3.94-2.2-8.733-2.366-13.184-1.587S14.464,43.735,10.13,45c-1.739.5-3.865.937-5.077-.6s-.106-3.83,1.352-5.14,3.338-2.3,4.116-4.1c.314-.707.418-1.489.732-2.205a2.123,2.123,0,0,1,1.694-1.4c.552-.029,1.051.248,1.542.072.775-.28.776-1.357.95-2.18.464-2.28,3.259-3.425,5.539-2.951S25.1,28.566,26.839,30.116Z",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M118.7,118.72a1.105,1.105,0,0,1-.811-1.686,7.621,7.621,0,0,0,1.494-3.9q-.063-1.723-2.325-4.006a.552.552,0,0,1-.03-.746c2.65-3.129,2.84-3.82,7.615-10.673s7.815-7.077,7.867-4.093-6.2,22.081-6.571,23.695-2.614,2.233-4.1,1.89A29.805,29.805,0,0,0,118.7,118.72Z",
    fill: "#1f1f1f",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 256,
    height: 256,
    transform: "translate(666 245)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnathorized);
export default __webpack_public_path__ + "static/media/Unathorized.a262b71d3922a5b8a2cf7317267ac6b4.svg";
export { ForwardRef as ReactComponent };